import React, { useEffect, useState } from "react";
import { Container, Input, Label } from "reactstrap";
import DataTableHelper from "../../../helpers/tables/DataTableHelper";
import Columns from "./Columns";
import DetailModal from "./Detail/DetailModal";
import { resourcesErrorLogs } from "../../../helpers/backend_helper";
import { DestroyAlertHelper, Alert } from "../../../helpers/alerts/alertHelper";
import { getStorageUser } from "../../../helpers/api_helper";

/**
 * Bitacora de crashes de la SPA. Solo la ve el Reseller (la ruta se cierra con
 * `policy: "routes"` en allRoutes.js y el backend vuelve a validarlo).
 */
const ErrorLogs = () => {
  const authUser = getStorageUser();
  const [pending, setPending] = useState(true);
  const [items, setItems] = useState([]);
  const [dataPag, setDataPag] = useState({ total: 0 });
  const [modal, setModal] = useState({ show: false, item: null });
  const [filters, setFilters] = useState({
    page: 1,
    perPage: 20,
    search: "",
    // Al reves que los catalogos: aqui lo reciente es lo relevante.
    orderBy: "created_at",
    order: "desc",
    date_from: "",
    date_to: "",
    companySession: authUser.company_id,
  });

  useEffect(() => {
    const getErrorLogs = async () => {
      setPending(true);
      const response = await resourcesErrorLogs("get", { params: filters });
      // Si el backend responde con la guarda de permisos, `data` no viene.
      setItems(response?.data ?? []);
      setDataPag(response?.meta ?? { total: 0 });
      setPending(false);
    };
    getErrorLogs();
  }, [filters]);

  const detail = (row) => {
    setModal({ show: true, item: row });
  };

  const destroy = (id) => {
    DestroyAlertHelper(async (confirmed) => {
      if (!confirmed) {
        return;
      }
      resourcesErrorLogs("del", id, id).then((response) => {
        Alert(response.message, response.status);
        if (response.status) {
          setItems(items.filter((i) => i.id != id));
        }
      });
    });
  };

  const columns = Columns(detail, destroy);
  document.title = "Errores del sistema | Sistema de logística";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="col-12">
            <DataTableHelper
              menuParent="Soporte"
              tittle="Errores del sistema"
              filterInp={true}
              columns={columns}
              items={items}
              pending={pending}
              config={dataPag}
              filters={filters}
              setFilters={setFilters}
            >
              <div className="col-sm-2">
                <Label className="mb-0">
                  <small className="text-muted">Desde</small>
                </Label>
                <Input
                  type="date"
                  value={filters.date_from}
                  onChange={(e) =>
                    setFilters({
                      ...filters,
                      date_from: e.target.value,
                      page: 1,
                    })
                  }
                />
              </div>
              <div className="col-sm-2">
                <Label className="mb-0">
                  <small className="text-muted">Hasta</small>
                </Label>
                <Input
                  type="date"
                  value={filters.date_to}
                  onChange={(e) =>
                    setFilters({ ...filters, date_to: e.target.value, page: 1 })
                  }
                />
              </div>
            </DataTableHelper>
          </div>
        </Container>

        {modal.show && <DetailModal modal={modal} setModal={setModal} />}
      </div>
    </React.Fragment>
  );
};

export default ErrorLogs;
